module.exports = __webpack_public_path__ + "img/MCU-Block-Diagram_old.059a4e7f.png";